import React, { PureComponent } from 'react';
import ReactMapGL from 'react-map-gl';
import PropTypes from 'prop-types';
import NavigationController from './NavigationController';
import { MAPBOX_TOKEN } from '../../config';
import { streets } from './MapStyle';
import { getViewport } from './util';
import { isEmptyArray } from '../../core/util/array';
import isEqual from 'lodash/isEqual';

class InteractiveMap extends PureComponent {
  state = {
    viewport: {
      width: this.props.width,
      height: this.props.height,
      latitude: this.props.latLong.latitude,
      longitude: this.props.latLong.longitude,
      zoom: this.props.zoom,
    },
  };

  componentDidMount() {
    if (this.props.updateZoomFromMarkers) {
      this.handleInitialZoomAdjustment();
    }
  }

  componentDidUpdate(prevProps) {
    const { children, height, width, latLong } = this.props;

    const markersChanged = children.length !== prevProps.children.length;
    const displayAreaChanged = height !== prevProps.height || width !== prevProps.width;
    const centerChanged = !isEqual(latLong, prevProps.latLong);

    if (displayAreaChanged || markersChanged || centerChanged) {
      this.updateViewport();
    }
  }

  updateViewport = () => {
    const {
      width,
      height,
      latLong: { latitude, longitude },
      zoom,
    } = this.props;
    const viewport = { width, height, latitude, longitude, zoom };
    this.setState({ viewport }, this.handleInitialZoomAdjustment);
  };

  handleInitialZoomAdjustment = () => {
    const { viewport } = this.state;
    const { children } = this.props;
    const markers = children.map(child => ({
      lat: child.props.latitude,
      lng: child.props.longitude,
    }));
    if (isEmptyArray(markers) || markers.length < 2) {
      return;
    }

    this.setState({ viewport: getViewport(viewport, markers) });
  };

  handleViewportChange = viewport => this.setState({ viewport });

  render() {
    const { children, width, height } = this.props;
    return (
      <ReactMapGL
        mapboxApiAccessToken={MAPBOX_TOKEN}
        mapStyle={streets}
        onViewportChange={this.handleViewportChange}
        attributionControl={false}
        {...this.state.viewport}
      >
        {children}
        <NavigationController handleViewportChange={this.handleViewportChange} />
      </ReactMapGL>
    );
  }
}

InteractiveMap.propTypes = {
  latLong: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  zoom: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.element),
  updateZoomFromMarkers: PropTypes.bool,
};

InteractiveMap.defaultProps = {
  zoom: 14,
  updateZoomFromMarkers: true,
  children: [],
};

export default InteractiveMap;
